module.exports = __webpack_public_path__ + "static/media/gray_animal_reptiles.27e6d2fa.png";